<template>
  <v-container fluid grid-list-lg>
    <v-layout wrap justify-center>
      <v-flex row align-center md10 class="title mt-4">
        <div>Permission setting</div>
        <v-icon class="icon mx-2" color="blue" @click="addPermissionClick">add_circle</v-icon>
      </v-flex>
      <v-flex md10>
        <v-text-field v-model="searchInput" label="Search by page route or group"></v-text-field>
        <div class="mb-2">Found {{ permissionsData.length }} results</div>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">ID</th>
                <th class="text-left">Page Route</th>
                <th class="text-left">Role</th>
                <th class="text-left">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="perm in permissionsData" :key="perm.id">
                <td>{{ perm.id }}</td>
                <td>{{ formatRouteKey(perm.pageRoute) }}</td>
                <td width="50%">
                  <v-select
                    v-model="perm.roles"
                    :items="originalRoles"
                    item-text="name"
                    item-value="id"
                    :item-disabled="isRoleDisabled"
                    multiple
                    chips
                    return-object
                  ></v-select>
                </td>
                <td>
                  <v-card-actions>
                    <v-btn color="primary" :disabled="!isDirty(perm.id)" @click="savePermissions(perm.id)">Save</v-btn>
                    <v-btn color="error" @click="deletePermission(perm.id)">Delete</v-btn>
                  </v-card-actions>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-flex>
    </v-layout>
    <v-dialog scrollable v-model="isAddPermissionOpen" width="600px">
      <v-card>
        <v-card-title>Add new page route</v-card-title>
        <v-card-text>
          <v-text-field
            v-model="formAddPermission.pageRoute"
            label="Page Route key"
            hint="use dot(.) to separate nested routes group (e.g., chat.chatroom, patient)"
          ></v-text-field>
          <v-select
            label="Select roles"
            v-model="formAddPermission.roles"
            :items="originalRoles"
            item-text="name"
            item-value="id"
            :item-disabled="isRoleDisabled"
            multiple
            chips
            return-object
          ></v-select>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="addPermissionClick"> Cancel </v-btn>
          <v-btn text @click="() => createPermission()" color="blue"> Save </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { Vue } from 'vue-property-decorator';
import roleService from '../../services/roles';
import permissionService from '../../services/permission';
import { debounce } from 'lodash';
export default Vue.extend({
  data() {
    return {
      roles: [],
      originalRoles: [],
      originalPermissions: [],
      permissionsData: [],
      searchInput: '',
      isAddPermissionOpen: false,
      formAddPermission: {
        pageRoute: '',
        roles: [{ id: 3 }],
      },
      debouncedFetch: null,
    };
  },
  watch: {
    searchInput(newVal) {
      this.debouncedFetch(newVal);
    },
  },
  methods: {
    formatRouteKey(route) {
      return route.replace(/\./g, '/');
    },
    fetchPermissions(keyword) {
      permissionService.getRolePermissions(keyword).then((permissions) => {
        this.permissionsData = permissions;
        this.originalPermissions = JSON.parse(JSON.stringify(permissions));
      });
    },

    fetchData() {
      roleService.getRoles().then((roles) => {
        this.originalRoles = roles;
        this.roles = roles.map((role) => role.name);
      });
      permissionService.getRolePermissions(this.searchInput).then((permissions) => {
        this.permissionsData = permissions;
        this.originalPermissions = JSON.parse(JSON.stringify(permissions));
      });
    },
    addPermissionClick() {
      this.isAddPermissionOpen = !this.isAddPermissionOpen;
      this.formAddPermission = {
        pageRoute: '',
        roles: [{ id: 3 }],
      };
    },
    createPermission() {
      const roleIds = this.formAddPermission.roles.map((role) => role.id);
      const payload = {
        pageRoute: this.formAddPermission.pageRoute,
        roleIds: roleIds,
      };
      permissionService
        .createPermission(payload.pageRoute, payload.roleIds)
        .then(() => {
          this.fetchData();
          this.$notify({
            title: 'Success',
            text: `Permission for <b>${this.formatRouteKey(payload.pageRoute)}</b> has been created.`,
            type: 'success',
          });
          this.isAddPermissionOpen = false;
        })
        .catch((error) => {
          this.fetchData();
          console.error('Error creating permission:', error);
          this.$notify({
            title: 'Error',
            text: `Failed to create permission for ${this.formatRouteKey(payload.pageRoute)}.`,
            type: 'error',
          });
        });
    },
    savePermissions(permId) {
      if (!this.isDirty(permId)) {
        return;
      }
      const perm = this.permissionsData.find((p) => p.id === permId);
      if (perm) {
        const roleIds = perm.roles.map((role) => role.id);
        const payload = {
          permId: permId,
          roleIds: roleIds,
        };
        permissionService
          .upsertRolePermission(payload.permId, payload.roleIds)
          .then(() => {
            this.fetchData();
            this.$notify({
              title: 'Success',
              text: `Permissions for ${this.formatRouteKey(perm.pageRoute)} have been updated.`,
              type: 'success',
            });
          })
          .catch((error) => {
            this.fetchData();
            console.error('Error updating permissions:', error);
            this.$notify({
              title: 'Error',
              text: `Failed to update permissions for ${this.formatRouteKey(perm.pageRoute)}.`,
              type: 'error',
            });
          });
      }
    },
    deletePermission(permId) {
      const perm = this.permissionsData.find((p) => p.id === permId);
      if (perm) {
        this.$root
          .$confirm(
            'Delete Permission',
            `Are you sure you want to delete permission for <b>${this.formatRouteKey(
              perm.pageRoute
            )}</b>? This action cannot be undone.`,
            { color: 'red' }
          )
          .then((confirm) => {
            if (confirm) {
              console.log('Deleting permission with:', perm.pageRoute);
              permissionService.deletePermission(permId).then(() => {
                this.fetchData();
                this.$notify({
                  title: 'Success',
                  text: `Permission for ${this.formatRouteKey(perm.pageRoute)} has been deleted.`,
                  type: 'success',
                });
              });
            }
          });
      }
    },
    isRoleDisabled(role) {
      return role.name === 'superadmin';
    },
    isDirty(permId) {
      const current = this.permissionsData.filter((p) => p.id === permId)[0].roles.map((r) => r.id);
      const original = this.originalPermissions.filter((p) => p.id === permId)[0].roles.map((r) => r.id);
      return !this.arraysEqual(current, original);
    },
    arraysEqual(arrA, arrB) {
      return arrA.length === arrB.length && arrA.every((value, index) => value === arrB[index]);
    },
  },
  mounted() {
    this.debouncedFetch = debounce(this.fetchPermissions, 400);
    this.fetchData();
  },
});
</script>
